import { useEffect, useState } from "react";
import api from "@/lib/api";

export function AdminStrategySessions() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/strategy-sessions").then((r) => setItems(r.data || [])); }, []);
  return (
    <div className="p-8" data-testid="admin-strategy-sessions">
      <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-[var(--terminal-brass)]">CMS</div>
      <h1 className="font-display font-black text-3xl text-[var(--terminal-text)] mt-1">Strategy Sessions</h1>
      <p className="mt-2 text-sm text-[var(--terminal-muted)]">Inbound bookings from /strategy-session.</p>
      <div className="mt-6 space-y-3">
        {items.map((it) => (
          <div key={it.id} className="terminal-card p-5">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-[var(--terminal-brass)]">{it.status || "new"}</div>
                <div className="font-display font-bold text-lg text-[var(--terminal-text)] mt-1">{it.name}</div>
                <div className="text-xs font-mono text-[var(--terminal-muted)] mt-1">{it.role} · {it.company}</div>
                <div className="text-xs font-mono text-[var(--terminal-muted)]">{it.email}{it.phone ? ` · ${it.phone}` : ""}</div>
              </div>
              <div className="text-right text-xs font-mono text-[var(--terminal-muted)]">
                {it.preferred_date && <div>📅 {it.preferred_date} {it.preferred_time_slot}</div>}
                {it.timezone && <div>{it.timezone}</div>}
                <div className="mt-1">{new Date(it.created_at).toLocaleString()}</div>
              </div>
            </div>
            <div className="mt-4 text-[10px] font-mono uppercase tracking-[0.22em] text-[var(--terminal-brass)]">Strategic Objective</div>
            <p className="mt-2 text-[14px] text-[var(--terminal-text)] whitespace-pre-wrap leading-relaxed">{it.objective}</p>
          </div>
        ))}
        {items.length === 0 && <div className="text-[var(--terminal-muted)] font-mono text-sm">No strategy sessions yet.</div>}
      </div>
    </div>
  );
}

export function AdminGeneratedBriefs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/generated-briefs").then((r) => setItems(r.data || [])); }, []);
  return (
    <div className="p-8" data-testid="admin-briefs">
      <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-[var(--terminal-brass)]">Luminous Intelligence</div>
      <h1 className="font-display font-black text-3xl text-[var(--terminal-text)] mt-1">Generated Briefs</h1>
      <p className="mt-2 text-sm text-[var(--terminal-muted)]">Briefs generated by users — review for lead-quality scoring.</p>
      <div className="mt-6 terminal-card overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b border-[var(--terminal-border)]">
              {["Brief", "User", "Confidence", "Inputs", "Created"].map((h) => <th key={h} className="text-left px-4 py-3 font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--terminal-brass)]">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} className="border-b border-[var(--terminal-border)]/50 align-top">
                <td className="px-4 py-3 text-[var(--terminal-text)]">{b.title}</td>
                <td className="px-4 py-3 text-[var(--terminal-text)] font-mono text-xs">{b.user_email || "anonymous"}</td>
                <td className="px-4 py-3 text-[var(--signal)] font-mono">{(b.confidence || 0).toFixed(2)}</td>
                <td className="px-4 py-3 text-[var(--terminal-muted)] text-xs max-w-md truncate">{JSON.stringify(b.inputs || {})}</td>
                <td className="px-4 py-3 text-[var(--terminal-muted)] text-xs whitespace-nowrap">{b.created_at ? new Date(b.created_at).toLocaleString() : ""}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[var(--terminal-muted)] font-mono text-sm">No briefs generated yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
